import HttpClient from 'services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL } from 'services/getBaseURL';
import { getUserToken } from 'services/utils';

const baseUrl = `${getBaseNewURL().base}`;
const http = new HttpClient();

const initialState = {
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	storeList: {
		Items: 0,
		Suppliers: [],
	},
	storeItem: undefined,
	storeSimilar: [],
	widgetList: [],
};

export const getSuppliersFilter = createAsyncThunk('SuppliersFilter', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	// Notice : Don't Remove Token
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${baseUrl}/SuppliersFilter`, params, extraConfig)

		.then((res) => {
			return res.data;
		});
	return response;
});

export const getSupplierInfo = createAsyncThunk('SupplierInfo', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	// Notice : Don't Remove Token
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http.post(`${baseUrl}/GetSupplierInfo`, params, extraConfig).then((res) => res.data);
	return response;
});

export const getSimilarStores = createAsyncThunk('similarStores', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${baseUrl}/GetRelatedSupplier`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

export const getWidgets = createAsyncThunk('stores', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${baseUrl}/GetWidgets`, params, extraConfig)

		.then((res) => {
			return res.data;
		});
	return response;
});

const _createStoreSlice = createSlice({
	name: 'new_store',
	initialState,
	reducers: {
		resetInitial(state) {
			state.storeList = {
				...state.storeList,
				Items: 0,
				Suppliers: [],
			};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getSuppliersFilter.pending, (state) => {
				state.isLoading.skeleton = true;
				state.storeItem = undefined;
			})
			.addCase(getSuppliersFilter.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Content } = action.payload;

				if (Success) {
					state.storeList = Content;
					state.storeItem = undefined;
				}
			})
			.addCase(getSuppliersFilter.rejected, (state) => {
				state.isLoading.skeleton = false;
			});

		builder
			.addCase(getSupplierInfo.pending, (state) => {
				state.isLoading.skeleton = true;
				state.storeItem = undefined;
			})
			.addCase(getSupplierInfo.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Content } = action.payload;

				if (Success && state.storeItem === undefined) {
					const logoSquare =
						Content?.SupplierInfo.ImageList.find((img) => img.SupplierImageTypeID === 1) || {};
					const logo = Content?.SupplierInfo.ImageList.find((img) => img.SupplierImageTypeID === 2) || {};
					const coverSquare =
						Content?.SupplierInfo.ImageList.find((img) => img.SupplierImageTypeID === 3) || {};
					const cover = Content?.SupplierInfo.ImageList.find((img) => img.SupplierImageTypeID === 4) || {};
					const coverWide =
						Content?.SupplierInfo.ImageList.find((img) => img.SupplierImageTypeID === 5) || {};
					const sliders =
						Content?.SupplierInfo.ImageList.filter((img) => img.SupplierImageTypeID === 10) || [];

					state.storeItem =
						{
							...Content?.SupplierInfo,
							ImageList: {
								logoSquare,
								logo,
								coverSquare,
								cover,
								coverWide,
								sliders,
							},
						} || {};
				}
			})
			.addCase(getSupplierInfo.rejected, (state) => {
				state.isLoading.skeleton = false;
			})
			.addCase(getSimilarStores.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getSimilarStores.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Content } = action.payload;

				if (Success) {
					state.storeSimilar = Content;
				}
			})
			.addCase(getSimilarStores.rejected, (state) => {
				state.isLoading.skeleton = false;
			})
			.addCase(getWidgets.pending, (state) => {
				state.storeItem = undefined;
			})
			.addCase(getWidgets.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;

				if (Success) {
					state.widgetList = Content.Zones.find((z) => z.Title === 'Center')?.Widgets;
				}

				state.storeList = {
					...state.storeList,
					Suppliers: [],
				};
			})
			.addCase(getWidgets.rejected, (state) => {
			});
	},
});

export const { resetStoreList, resetInitial } = _createStoreSlice.actions;
export default _createStoreSlice.reducer;
